var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-chart-scatter"},[_c('div',{ref:"workspace"})])
}
var staticRenderFns = []

export { render, staticRenderFns }